import * as AppConstants from '../constants/AppConstants'

export const submitBookingStep = bookingStep => ({
  type: AppConstants.BOOKING_ACTION.STEP_SUBMIT,
  payload: { stepName: bookingStep }
})

export const completeBookingStep = (bookingStep, formValues) => ({
  type: AppConstants.BOOKING_ACTION.STEP_COMPLETE,
  payload: { stepName: bookingStep, data: formValues }
})

export const errorOutBookingStep = bookingStep => ({
  type: AppConstants.BOOKING_ACTION.STEP_ERROR,
  payload: { stepName: bookingStep }
})

export const jumpToBookingStep = bookingStep => ({
  type: AppConstants.BOOKING_ACTION.JUMP_TO_STEP,
  payload: { stepName: bookingStep }
})

export const resetBooking = () => ({
  type: AppConstants.BOOKING_ACTION.RESET,
  payload: null
})

export const toggleServiceSelection = serviceName => ({
  type: AppConstants.SERVICE_SELECTION.TOGGLE_SERVICE_SELECTION,
  payload: { serviceName: serviceName }
})

export const setServiceData = (serviceName, data) => ({
  type: AppConstants.SERVICE_SELECTION.SET_SERVICE_DATA,
  payload: { serviceName: serviceName, data: data }
})

export const setAdditionalNotes = data => ({
  type: AppConstants.SERVICE_SELECTION.SET_ADDITIONAL_NOTES,
  payload: { serviceName: [AppConstants.SERVICE_OPTIONS.ADDITIONAL_NOTES], data: data }
})

export const setCar = car => ({
  type: AppConstants.BOOKING_ACTION.SET_CAR,
  payload: { car: car }
})



// WEBPACK FOOTER //
// ./src/actions/BookingActions.js